// Magnus-Konstanten (°C)
export const A = 17.62;
export const B = 243.12;
// Skalen-Obergrenze der Feuchte-Balken [g/m³]
export const AH_MAX = 30;

// Taupunkt aus Temperatur (°C) und relativer Feuchte (%)
export function taupunkt(t, rh) {
  const alpha = Math.log(rh / 100) + (A * t) / (B + t);
  return (B * alpha) / (A - alpha);
}

// Absolute Feuchte in g/m³ aus Temperatur und relativer Feuchte
export function absFeuchte(t, rh) {
  const e = (rh / 100) * 6.112 * Math.exp((A * t) / (B + t)); // Dampfdruck [hPa]
  return (216.7 * e) / (273.15 + t);
}
